var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_136_451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_136_451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 20.3333C6.9 20.3333 3 16.4333 3 11.6667C3 6.9 6.9 3 11.6667 3C16.4333 3 20.3333 6.9 20.3333 11.6667C20.3333 16.4333 16.4333 20.3333 11.6667 20.3333ZM11.6667 3.92857C7.39524 3.92857 3.92857 7.39524 3.92857 11.6667C3.92857 15.9381 7.39524 19.4048 11.6667 19.4048C15.9381 19.4048 19.4048 15.9381 19.4048 11.6667C19.4048 7.39524 15.9381 3.92857 11.6667 3.92857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.869 12.1308H3.46429C3.21667 12.1308 3 11.9142 3 11.6666C3 11.4189 3.21667 11.2023 3.46429 11.2023H19.869C20.1167 11.2023 20.3333 11.4189 20.3333 11.6666C20.3333 11.9142 20.1167 12.1308 19.869 12.1308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 20.3333C9.53096 20.3333 7.92143 16.619 7.92143 11.6667C7.92143 6.71428 9.53096 3 11.6667 3C13.8024 3 15.4119 6.71428 15.4119 11.6667C15.4119 16.619 13.8024 20.3333 11.6667 20.3333ZM11.6667 3.92857C10.3357 3.92857 8.85 7.11666 8.85 11.6667C8.85 16.2167 10.3357 19.4048 11.6667 19.4048C12.9976 19.4048 14.4833 16.2167 14.4833 11.6667C14.4833 7.11666 12.9976 3.92857 11.6667 3.92857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 8.84996C9.34524 8.84996 7.17857 7.95234 5.5381 6.31187C5.35238 6.12615 5.35238 5.84758 5.5381 5.66187C5.72381 5.47615 6.00238 5.47615 6.1881 5.66187C7.64286 7.11663 9.59286 7.92139 11.6667 7.92139C13.7405 7.92139 15.6905 7.11663 17.1452 5.66187C17.3309 5.47615 17.6095 5.47615 17.7952 5.66187C17.9809 5.84758 17.9809 6.12615 17.7952 6.31187C16.1548 7.95234 13.9881 8.84996 11.6667 8.84996ZM17.4548 17.8261C17.3309 17.8261 17.2071 17.7952 17.1143 17.7023C15.6595 16.2476 13.7095 15.4428 11.6357 15.4428C9.5619 15.4428 7.61191 16.2476 6.15714 17.7023C5.97143 17.8881 5.69286 17.8881 5.50714 17.7023C5.32143 17.5166 5.32143 17.2381 5.50714 17.0523C7.14762 15.4119 9.31429 14.5142 11.6357 14.5142C13.9571 14.5142 16.1238 15.4119 17.7643 17.0523C17.95 17.2381 17.95 17.5166 17.7643 17.7023C17.7024 17.7642 17.5786 17.8261 17.4548 17.8261Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.ebe2852250b43364bd784cf382b9a48f.svg";
export { ForwardRef as ReactComponent };